export const NotFoundPage = () => {
  return (
    <>404</>
  )
}